var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightCornerMediumBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 51,
    viewBox: "0 0 74 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5669_18827",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 174,
    height: 51
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 173.067,
    height: 50.1726,
    transform: "matrix(-1 -8.8552e-08 -8.6308e-08 1 173.067 0.523438)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5669_18827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4991 25.677L73.358 25.677L73.358 50.9703L48.4991 50.9703L48.4991 25.677Z",
    fill: "#CC5E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6329 0.383785L48.4989 0.383789L48.4989 25.6771L23.6329 0.383785Z",
    fill: "#992C21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6329 25.677L48.4989 25.677L48.4989 50.9774L23.6329 25.677Z",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6332 50.9774L-1.22575 50.9774L-1.22575 25.677L23.6332 50.9774Z",
    fill: "#9E7E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4989 0.383789L48.4989 25.6771L23.6329 25.6771L48.4989 0.383789Z",
    fill: "#BD3728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.22575 25.677L23.6332 25.677L23.6332 50.9774L-1.22575 25.677Z",
    fill: "#C59A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3579 0.383785L98.2168 0.383789L98.2168 25.6771L73.3579 0.383785Z",
    fill: "#06B395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2168 25.6771L73.3579 25.6771L73.3579 0.383785L98.2168 25.6771Z",
    fill: "#049078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0659 13.034L23.6329 0.383787L23.6329 25.6771L36.0659 13.034Z",
    fill: "#CC5D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4991 0.383785L73.358 0.383789L73.358 25.6771L48.4991 25.6771L48.4991 0.383785Z",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1415 10.9282C64.8514 10.9282 62.9949 9.03926 62.9949 6.70911C62.9949 4.37895 64.8514 2.48999 67.1415 2.48999C69.4317 2.48999 71.2882 4.37895 71.2882 6.70911C71.2882 9.03926 69.4317 10.9282 67.1415 10.9282Z",
    fill: "#377FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1415 23.5779C64.8514 23.5779 62.9949 21.6889 62.9949 19.3588C62.9949 17.0286 64.8514 15.1396 67.1415 15.1396C69.4317 15.1396 71.2882 17.0286 71.2882 19.3588C71.2882 21.6889 69.4317 23.5779 67.1415 23.5779Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7086 10.9282C52.4184 10.9282 50.5619 9.03926 50.5619 6.70911C50.5619 4.37895 52.4184 2.48999 54.7086 2.48999C56.9987 2.48999 58.8552 4.37895 58.8552 6.70911C58.8552 9.03926 56.9987 10.9282 54.7086 10.9282Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7086 23.5779C52.4184 23.5779 50.5619 21.6889 50.5619 19.3588C50.5619 17.0286 52.4184 15.1396 54.7086 15.1396C56.9987 15.1396 58.8552 17.0286 58.8552 19.3588C58.8552 21.6889 56.9987 23.5779 54.7086 23.5779Z",
    fill: "#377FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3579 25.677L98.2168 25.677L98.2168 32.0021L73.3579 32.0021L73.3579 25.677Z",
    fill: "#C59A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3579 44.6526L98.2168 44.6526L98.2168 50.9777L73.3579 50.9777L73.3579 44.6526Z",
    fill: "#9E7E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3579 32.0022L98.2168 32.0022L98.2168 38.3273L73.3579 38.3273L73.3579 32.0022Z",
    fill: "#9E7E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3579 38.3276L98.2168 38.3276L98.2168 44.6527L73.3579 44.6527L73.3579 38.3276Z",
    fill: "#C59A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9251 50.9774C54.0585 50.9774 48.4921 45.3137 48.4921 38.3272C48.4921 31.3407 54.0585 25.677 60.9251 25.677C67.7916 25.677 73.358 31.3407 73.358 38.3272C73.358 45.3137 67.7916 50.9774 60.9251 50.9774Z",
    fill: "#F27544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9254 44.6524C57.4921 44.6524 54.7089 41.8206 54.7089 38.3273C54.7089 34.834 57.4921 32.0022 60.9254 32.0022C64.3586 32.0022 67.1418 34.834 67.1418 38.3273C67.1418 41.8206 64.3586 44.6524 60.9254 44.6524Z",
    fill: "#F9AB8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9961 25.677L48.4989 40.4332L48.4989 50.9774L23.6329 25.677L33.9961 25.677Z",
    fill: "#0C4D91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1358 50.9774L23.6329 36.2212L23.6329 25.677L48.4989 50.9774L38.1358 50.9774Z",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6331 50.9779L23.6331 36.2217L38.1359 50.9779L23.6331 50.9779Z",
    fill: "#0C4D91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6332 58.0597L23.6332 36.2217L45.0962 58.0597L23.6332 58.0597Z",
    fill: "#0C4D91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCornerMediumBg);
export default __webpack_public_path__ + "static/media/right_corner_medium_bg.36bd3c74c29375a67c33075fc672df7d.svg";
export { ForwardRef as ReactComponent };